[
  {
    "code": "IN-TS-AD",
    "name": "Adilabad"
  },
  {
    "code": "IN-MP-AM",
    "name": "Agar Malwa"
  },
  {
    "code": "IN-UP-AG",
    "name": "Agra"
  },
  {
    "code": "IN-GJ-AH",
    "name": "Ahmedabad"
  },
  {
    "code": "IN-MH-AH",
    "name": "Ahmednagar"
  },
  {
    "code": "IN-MZ-AI",
    "name": "Aizawl"
  },
  {
    "code": "IN-RJ-AJ",
    "name": "Ajmer"
  },
  {
    "code": "IN-MH-AK",
    "name": "Akola"
  },
  {
    "code": "IN-KL-AL",
    "name": "Alappuzha"
  },
  {
    "code": "IN-UP-AL",
    "name": "Aligarh"
  },
  {
    "code": "IN-WB-AL",
    "name": "Alipurduar"
  },
  {
    "code": "IN-MP-AL",
    "name": "Alirajpur"
  },
  {
    "code": "IN-UL-AL",
    "name": "Almora"
  },
  {
    "code": "IN-RJ-AL",
    "name": "Alwar"
  },
  {
    "code": "IN-HR-AM",
    "name": "Ambala"
  },
  {
    "code": "IN-UP-AN",
    "name": "Ambedkar Nagar"
  },
  {
    "code": "IN-UP-AE",
    "name": "Amethi"
  },
  {
    "code": "IN-MH-AM",
    "name": "Amravati"
  },
  {
    "code": "IN-GJ-AM",
    "name": "Amreli"
  },
  {
    "code": "IN-PB-AM",
    "name": "Amritsar"
  },
  {
    "code": "IN-UP-JP",
    "name": "Amroha"
  },
  {
    "code": "IN-GJ-AN",
    "name": "Anand"
  },
  {
    "code": "IN-AP-AN",
    "name": "Anantapuramu"
  },
  {
    "code": "IN-JK-AN",
    "name": "Anantnag"
  },
  {
    "code": "IN-OR-AN",
    "name": "Angul"
  },
  {
    "code": "IN-AR-AN",
    "name": "Anjaw"
  },
  {
    "code": "IN-MP-AN",
    "name": "Anuppur"
  },
  {
    "code": "IN-BR-AR",
    "name": "Araria"
  },
  {
    "code": "IN-GJ-AR",
    "name": "Aravalli"
  },
  {
    "code": "IN-TN-AR",
    "name": "Ariyalur"
  },
  {
    "code": "IN-BR-AW",
    "name": "Arwal"
  },
  {
    "code": "IN-MP-AS",
    "name": "Ashoknagar"
  },
  {
    "code": "IN-UP-AU",
    "name": "Auraiya"
  },
  {
    "code": "IN-MH-AU",
    "name": "Aurangabad"
  },
  {
    "code": "IN-BR-AU",
    "name": "Aurangabad"
  },
  {
    "code": "IN-UP-FZ",
    "name": "Ayodhya"
  },
  {
    "code": "IN-UP-AZ",
    "name": "Azamgarh"
  },
  {
    "code": "IN-KA-BK",
    "name": "Bagalkote"
  },
  {
    "code": "IN-UL-BA",
    "name": "Bageshwar"
  },
  {
    "code": "IN-UP-BG",
    "name": "Baghpat"
  },
  {
    "code": "IN-UP-BH",
    "name": "Bahraich"
  },
  {
    "code": "IN-AS-BK",
    "name": "Baksa"
  },
  {
    "code": "IN-MP-BL",
    "name": "Balaghat"
  },
  {
    "code": "IN-OR-BL",
    "name": "Balangir"
  },
  {
    "code": "IN-OR-BW",
    "name": "Baleswar"
  },
  {
    "code": "IN-KA-BL",
    "name": "Ballari"
  },
  {
    "code": "IN-UP-BL",
    "name": "Ballia"
  },
  {
    "code": "IN-CT-BD",
    "name": "Balod"
  },
  {
    "code": "IN-CT-BB",
    "name": "Baloda Bazar"
  },
  {
    "code": "IN-UP-BP",
    "name": "Balrampur"
  },
  {
    "code": "IN-CT-BP",
    "name": "Balrampur"
  },
  {
    "code": "IN-GJ-BK",
    "name": "Banaskantha"
  },
  {
    "code": "IN-UP-BN",
    "name": "Banda"
  },
  {
    "code": "IN-JK-BN",
    "name": "Bandipora"
  },
  {
    "code": "IN-BR-BA",
    "name": "Banka"
  },
  {
    "code": "IN-WB-BN",
    "name": "Bankura"
  },
  {
    "code": "IN-RJ-BN",
    "name": "Banswara"
  },
  {
    "code": "IN-UP-BB",
    "name": "Barabanki"
  },
  {
    "code": "IN-JK-BR",
    "name": "Baramulla"
  },
  {
    "code": "IN-RJ-BR",
    "name": "Baran"
  },
  {
    "code": "IN-UP-BR",
    "name": "Bareilly"
  },
  {
    "code": "IN-OR-BR",
    "name": "Bargarh"
  },
  {
    "code": "IN-RJ-BM",
    "name": "Barmer"
  },
  {
    "code": "IN-PB-BR",
    "name": "Barnala"
  },
  {
    "code": "IN-AS-BA",
    "name": "Barpeta"
  },
  {
    "code": "IN-MP-BR",
    "name": "Barwani"
  },
  {
    "code": "IN-CT-BA",
    "name": "Bastar"
  },
  {
    "code": "IN-UP-BS",
    "name": "Basti"
  },
  {
    "code": "IN-PB-BA",
    "name": "Bathinda"
  },
  {
    "code": "IN-MH-BI",
    "name": "Beed"
  },
  {
    "code": "IN-BR-BE",
    "name": "Begusarai"
  },
  {
    "code": "IN-KA-BG",
    "name": "Belagavi"
  },
  {
    "code": "IN-CT-BM",
    "name": "Bemetara"
  },
  {
    "code": "IN-KA-BR",
    "name": "Bengaluru Rural"
  },
  {
    "code": "IN-KA-BN",
    "name": "Bengaluru Urban"
  },
  {
    "code": "IN-MP-BE",
    "name": "Betul"
  },
  {
    "code": "IN-UP-SR",
    "name": "Bhadohi"
  },
  {
    "code": "IN-TS-BK",
    "name": "Bhadradri Kothagudem"
  },
  {
    "code": "IN-OR-BH",
    "name": "Bhadrak"
  },
  {
    "code": "IN-BR-BG",
    "name": "Bhagalpur"
  },
  {
    "code": "IN-MH-BH",
    "name": "Bhandara"
  },
  {
    "code": "IN-RJ-BP",
    "name": "Bharatpur"
  },
  {
    "code": "IN-GJ-BR",
    "name": "Bharuch"
  },
  {
    "code": "IN-GJ-BV",
    "name": "Bhavnagar"
  },
  {
    "code": "IN-RJ-BW",
    "name": "Bhilwara"
  },
  {
    "code": "IN-MP-BD",
    "name": "Bhind"
  },
  {
    "code": "IN-HR-BH",
    "name": "Bhiwani"
  },
  {
    "code": "IN-BR-BJ",
    "name": "Bhojpur"
  },
  {
    "code": "IN-MP-BP",
    "name": "Bhopal"
  },
  {
    "code": "IN-KA-BD",
    "name": "Bidar"
  },
  {
    "code": "IN-CT-BJ",
    "name": "Bijapur"
  },
  {
    "code": "IN-UP-BI",
    "name": "Bijnor"
  },
  {
    "code": "IN-RJ-BI",
    "name": "Bikaner"
  },
  {
    "code": "IN-CT-BI",
    "name": "Bilaspur"
  },
  {
    "code": "IN-HP-BI",
    "name": "Bilaspur"
  },
  {
    "code": "IN-WB-BI",
    "name": "Birbhum"
  },
  {
    "code": "IN-MN-BI",
    "name": "Bishnupur"
  },
  {
    "code": "IN-AS-BI",
    "name": "Biswanath"
  },
  {
    "code": "IN-JH-BO",
    "name": "Bokaro"
  },
  {
    "code": "IN-AS-BO",
    "name": "Bongaigaon"
  },
  {
    "code": "IN-GJ-BO",
    "name": "Botad"
  },
  {
    "code": "IN-OR-BD",
    "name": "Boudh"
  },
  {
    "code": "IN-UP-BD",
    "name": "Budaun"
  },
  {
    "code": "IN-JK-BD",
    "name": "Budgam"
  },
  {
    "code": "IN-UP-BU",
    "name": "Bulandshahr"
  },
  {
    "code": "IN-MH-BU",
    "name": "Buldhana"
  },
  {
    "code": "IN-RJ-BU",
    "name": "Bundi"
  },
  {
    "code": "IN-MP-BU",
    "name": "Burhanpur"
  },
  {
    "code": "IN-BR-BU",
    "name": "Buxar"
  },
  {
    "code": "IN-AS-CA",
    "name": "Cachar"
  },
  {
    "code": "IN-DL-CE",
    "name": "Central Delhi"
  },
  {
    "code": "IN-KA-CJ",
    "name": "Chamarajanagara"
  },
  {
    "code": "IN-HP-CH",
    "name": "Chamba"
  },
  {
    "code": "IN-UL-CL",
    "name": "Chamoli"
  },
  {
    "code": "IN-UL-CP",
    "name": "Champawat"
  },
  {
    "code": "IN-MZ-CH",
    "name": "Champhai"
  },
  {
    "code": "IN-UP-CD",
    "name": "Chandauli"
  },
  {
    "code": "IN-MN-CD",
    "name": "Chandel"
  },
  {
    "code": "IN-CH-CH",
    "name": "Chandigarh"
  },
  {
    "code": "IN-MH-CH",
    "name": "Chandrapur"
  },
  {
    "code": "IN-AR-CH",
    "name": "Changlang"
  },
  {
    "code": "IN-AS-CH",
    "name": "Charaideo"
  },
  {
    "code": "IN-HR-CD",
    "name": "Charki Dadri"
  },
  {
    "code": "IN-JH-CH",
    "name": "Chatra"
  },
  {
    "code": "IN-TN-CP",
    "name": "Chengalpattu"
  },
  {
    "code": "IN-TN-CH",
    "name": "Chennai"
  },
  {
    "code": "IN-MP-CT",
    "name": "Chhatarpur"
  },
  {
    "code": "IN-MP-CN",
    "name": "Chhindwara"
  },
  {
    "code": "IN-GJ-CU",
    "name": "Chhota Udaipur"
  },
  {
    "code": "IN-KA-CH",
    "name": "Chikkaballapura"
  },
  {
    "code": "IN-KA-CK",
    "name": "Chikkamagaluru"
  },
  {
    "code": "IN-AS-CR",
    "name": "Chirang"
  },
  {
    "code": "IN-KA-CT",
    "name": "Chitradurga"
  },
  {
    "code": "IN-UP-CT",
    "name": "Chitrakoot"
  },
  {
    "code": "IN-AP-CH",
    "name": "Chittoor"
  },
  {
    "code": "IN-RJ-CT",
    "name": "Chittorgarh"
  },
  {
    "code": "IN-MN-CC",
    "name": "Churachandpur"
  },
  {
    "code": "IN-RJ-CR",
    "name": "Churu"
  },
  {
    "code": "IN-TN-CO",
    "name": "Coimbatore"
  },
  {
    "code": "IN-WB-KB",
    "name": "Cooch Behar"
  },
  {
    "code": "IN-TN-CU",
    "name": "Cuddalore"
  },
  {
    "code": "IN-OR-CU",
    "name": "Cuttack"
  },
  {
    "code": "IN-DN-DN",
    "name": "Dadra & Nagar Haveli"
  },
  {
    "code": "IN-GJ-DA",
    "name": "Dahod"
  },
  {
    "code": "IN-WB-DD",
    "name": "Dakshin Dinajpur"
  },
  {
    "code": "IN-KA-DK",
    "name": "Dakshina Kannada"
  },
  {
    "code": "IN-DD-DA",
    "name": "Daman"
  },
  {
    "code": "IN-MP-DM",
    "name": "Damoh"
  },
  {
    "code": "IN-GJ-DG",
    "name": "Dang"
  },
  {
    "code": "IN-CT-DA",
    "name": "Dantewada"
  },
  {
    "code": "IN-BR-DA",
    "name": "Darbhanga"
  },
  {
    "code": "IN-WB-DA",
    "name": "Darjeeling"
  },
  {
    "code": "IN-AS-DA",
    "name": "Darrang"
  },
  {
    "code": "IN-MP-DT",
    "name": "Datia"
  },
  {
    "code": "IN-RJ-DA",
    "name": "Dausa"
  },
  {
    "code": "IN-KA-DA",
    "name": "Davanagere"
  },
  {
    "code": "IN-UL-DD",
    "name": "Dehradun"
  },
  {
    "code": "IN-OR-DE",
    "name": "Deogarh"
  },
  {
    "code": "IN-JH-DE",
    "name": "Deoghar"
  },
  {
    "code": "IN-UP-DE",
    "name": "Deoria"
  },
  {
    "code": "IN-GJ-DD",
    "name": "Devbhumi Dwarka"
  },
  {
    "code": "IN-MP-DE",
    "name": "Dewas"
  },
  {
    "code": "IN-TR-DH",
    "name": "Dhalai"
  },
  {
    "code": "IN-CT-DH",
    "name": "Dhamtari"
  },
  {
    "code": "IN-JH-DH",
    "name": "Dhanbad"
  },
  {
    "code": "IN-MP-DH",
    "name": "Dhar"
  },
  {
    "code": "IN-TN-DH",
    "name": "Dharmapuri"
  },
  {
    "code": "IN-KA-DH",
    "name": "Dharwad"
  },
  {
    "code": "IN-AS-DM",
    "name": "Dhemaji"
  },
  {
    "code": "IN-OR-DH",
    "name": "Dhenkanal"
  },
  {
    "code": "IN-RJ-DH",
    "name": "Dholpur"
  },
  {
    "code": "IN-AS-DB",
    "name": "Dhubri"
  },
  {
    "code": "IN-MH-DH",
    "name": "Dhule"
  },
  {
    "code": "IN-AS-DI",
    "name": "Dibrugarh"
  },
  {
    "code": "IN-AS-NC",
    "name": "Dima Hasao"
  },
  {
    "code": "IN-NL-DI",
    "name": "Dimapur"
  },
  {
    "code": "IN-TN-DI",
    "name": "Dindigul"
  },
  {
    "code": "IN-MP-DI",
    "name": "Dindori"
  },
  {
    "code": "IN-DD-DI",
    "name": "Diu"
  },
  {
    "code": "IN-JK-DO",
    "name": "Doda"
  },
  {
    "code": "IN-JH-DU",
    "name": "Dumka"
  },
  {
    "code": "IN-RJ-DU",
    "name": "Dungarpur"
  },
  {
    "code": "IN-CT-DU",
    "name": "Durg"
  },
  {
    "code": "IN-DL-EA",
    "name": "East Delhi"
  },
  {
    "code": "IN-ML-EG",
    "name": "East Garo Hills"
  },
  {
    "code": "IN-AP-EG",
    "name": "East Godavari"
  },
  {
    "code": "IN-ML-EJ",
    "name": "East Jaintia Hills"
  },
  {
    "code": "IN-AR-EK",
    "name": "East Kameng"
  },
  {
    "code": "IN-ML-EK",
    "name": "East Khasi Hills"
  },
  {
    "code": "IN-AR-ES",
    "name": "East Siang"
  },
  {
    "code": "IN-SK-ES",
    "name": "East Sikkim"
  },
  {
    "code": "IN-JH-ES",
    "name": "East Singhbhum"
  },
  {
    "code": "IN-KL-ER",
    "name": "Ernakulam"
  },
  {
    "code": "IN-TN-ER",
    "name": "Erode"
  },
  {
    "code": "IN-UP-ET",
    "name": "Etah"
  },
  {
    "code": "IN-UP-EW",
    "name": "Etawah"
  },
  {
    "code": "IN-HR-FR",
    "name": "Faridabad"
  },
  {
    "code": "IN-PB-FR",
    "name": "Faridkot"
  },
  {
    "code": "IN-UP-FR",
    "name": "Farrukhabad"
  },
  {
    "code": "IN-HR-FT",
    "name": "Fatehabad"
  },
  {
    "code": "IN-PB-FT",
    "name": "Fatehgarh Sahib"
  },
  {
    "code": "IN-UP-FT",
    "name": "Fatehpur"
  },
  {
    "code": "IN-PB-FA",
    "name": "Fazilka"
  },
  {
    "code": "IN-PB-FI",
    "name": "Ferozepur"
  },
  {
    "code": "IN-UP-FI",
    "name": "Firozabad"
  },
  {
    "code": "IN-KA-GA",
    "name": "Gadag"
  },
  {
    "code": "IN-MH-GA",
    "name": "Gadchiroli"
  },
  {
    "code": "IN-OR-GP",
    "name": "Gajapati"
  },
  {
    "code": "IN-JK-GN",
    "name": "Ganderbal"
  },
  {
    "code": "IN-GJ-GA",
    "name": "Gandhinagar"
  },
  {
    "code": "IN-OR-GN",
    "name": "Ganjam"
  },
  {
    "code": "IN-JH-GA",
    "name": "Garhwa"
  },
  {
    "code": "IN-CT-GA",
    "name": "Gariaband"
  },
  {
    "code": "IN-UP-GB",
    "name": "Gautam Buddha Nagar"
  },
  {
    "code": "IN-BR-GA",
    "name": "Gaya"
  },
  {
    "code": "IN-UP-GZ",
    "name": "Ghaziabad"
  },
  {
    "code": "IN-UP-GP",
    "name": "Ghazipur"
  },
  {
    "code": "IN-GJ-GS",
    "name": "Gir Somnath"
  },
  {
    "code": "IN-JH-GI",
    "name": "Giridih"
  },
  {
    "code": "IN-AS-GP",
    "name": "Goalpara"
  },
  {
    "code": "IN-JH-GO",
    "name": "Godda"
  },
  {
    "code": "IN-AS-GG",
    "name": "Golaghat"
  },
  {
    "code": "IN-TR-GO",
    "name": "Gomati"
  },
  {
    "code": "IN-UP-GN",
    "name": "Gonda"
  },
  {
    "code": "IN-MH-GO",
    "name": "Gondia"
  },
  {
    "code": "IN-BR-GO",
    "name": "Gopalganj"
  },
  {
    "code": "IN-UP-GR",
    "name": "Gorakhpur"
  },
  {
    "code": "IN-JH-GU",
    "name": "Gumla"
  },
  {
    "code": "IN-MP-GU",
    "name": "Guna"
  },
  {
    "code": "IN-AP-GU",
    "name": "Guntur"
  },
  {
    "code": "IN-PB-GU",
    "name": "Gurdaspur"
  },
  {
    "code": "IN-HR-GU",
    "name": "Gurugram"
  },
  {
    "code": "IN-MP-GW",
    "name": "Gwalior"
  },
  {
    "code": "IN-AS-HA",
    "name": "Hailakandi"
  },
  {
    "code": "IN-UP-HM",
    "name": "Hamirpur"
  },
  {
    "code": "IN-HP-HA",
    "name": "Hamirpur"
  },
  {
    "code": "IN-RJ-HA",
    "name": "Hanumangarh"
  },
  {
    "code": "IN-UP-HP",
    "name": "Hapur"
  },
  {
    "code": "IN-MP-HA",
    "name": "Harda"
  },
  {
    "code": "IN-UP-HR",
    "name": "Hardoi"
  },
  {
    "code": "IN-UL-HA",
    "name": "Haridwar"
  },
  {
    "code": "IN-KA-HS",
    "name": "Hassan"
  },
  {
    "code": "IN-UP-HT",
    "name": "Hathras"
  },
  {
    "code": "IN-KA-HV",
    "name": "Haveri"
  },
  {
    "code": "IN-JH-HA",
    "name": "Hazaribagh"
  },
  {
    "code": "IN-MH-HI",
    "name": "Hingoli"
  },
  {
    "code": "IN-HR-HI",
    "name": "Hisar"
  },
  {
    "code": "IN-MZ-HN",
    "name": "Hnahthial"
  },
  {
    "code": "IN-AS-HO",
    "name": "Hojai"
  },
  {
    "code": "IN-WB-HG",
    "name": "Hooghly"
  },
  {
    "code": "IN-PB-HO",
    "name": "Hoshiarpur"
  },
  {
    "code": "IN-WB-HR",
    "name": "Howrah"
  },
  {
    "code": "IN-TS-HY",
    "name": "Hyderabad"
  },
  {
    "code": "IN-KL-ID",
    "name": "Idukki"
  },
  {
    "code": "IN-MN-EI",
    "name": "Imphal East"
  },
  {
    "code": "IN-MN-WI",
    "name": "Imphal West"
  },
  {
    "code": "IN-MP-IN",
    "name": "Indore"
  },
  {
    "code": "IN-MP-JA",
    "name": "Jabalpur"
  },
  {
    "code": "IN-OR-JS",
    "name": "Jagatsinghpur"
  },
  {
    "code": "IN-TS-JA",
    "name": "Jagitial"
  },
  {
    "code": "IN-RJ-JP",
    "name": "Jaipur"
  },
  {
    "code": "IN-RJ-JS",
    "name": "Jaisalmer"
  },
  {
    "code": "IN-OR-JP",
    "name": "Jajpur"
  },
  {
    "code": "IN-PB-JA",
    "name": "Jalandhar"
  },
  {
    "code": "IN-UP-JL",
    "name": "Jalaun"
  },
  {
    "code": "IN-MH-JG",
    "name": "Jalgaon"
  },
  {
    "code": "IN-MH-JN",
    "name": "Jalna"
  },
  {
    "code": "IN-RJ-JL",
    "name": "Jalore"
  },
  {
    "code": "IN-WB-JA",
    "name": "Jalpaiguri"
  },
  {
    "code": "IN-JK-JA",
    "name": "Jammu"
  },
  {
    "code": "IN-GJ-JA",
    "name": "Jamnagar"
  },
  {
    "code": "IN-JH-JA",
    "name": "Jamtara"
  },
  {
    "code": "IN-BR-JA",
    "name": "Jamui"
  },
  {
    "code": "IN-TS-JN",
    "name": "Jangaon"
  },
  {
    "code": "IN-CT-JC",
    "name": "Janjgir-Champa"
  },
  {
    "code": "IN-CT-JA",
    "name": "Jashpur"
  },
  {
    "code": "IN-UP-JU",
    "name": "Jaunpur"
  },
  {
    "code": "IN-TS-JY",
    "name": "Jayashankar"
  },
  {
    "code": "IN-BR-JE",
    "name": "Jehanabad"
  },
  {
    "code": "IN-MP-JH",
    "name": "Jhabua"
  },
  {
    "code": "IN-HR-JH",
    "name": "Jhajjar"
  },
  {
    "code": "IN-RJ-JW",
    "name": "Jhalawar"
  },
  {
    "code": "IN-UP-JH",
    "name": "Jhansi"
  },
  {
    "code": "IN-WB-JH",
    "name": "Jhargram"
  },
  {
    "code": "IN-OR-JH",
    "name": "Jharsuguda"
  },
  {
    "code": "IN-RJ-JJ",
    "name": "Jhunjhunu"
  },
  {
    "code": "IN-HR-JI",
    "name": "Jind"
  },
  {
    "code": "IN-MN-JI",
    "name": "Jiribam"
  },
  {
    "code": "IN-RJ-JO",
    "name": "Jodhpur"
  },
  {
    "code": "IN-TS-JG",
    "name": "Jogulamba Gadwal"
  },
  {
    "code": "IN-AS-JO",
    "name": "Jorhat"
  },
  {
    "code": "IN-GJ-JU",
    "name": "Junagadh"
  },
  {
    "code": "IN-CT-KW",
    "name": "Kabirdham"
  },
  {
    "code": "IN-GJ-KA",
    "name": "Kachchh"
  },
  {
    "code": "IN-BR-KM",
    "name": "Kaimur"
  },
  {
    "code": "IN-HR-KT",
    "name": "Kaithal"
  },
  {
    "code": "IN-MN-KK",
    "name": "Kakching"
  },
  {
    "code": "IN-KA-GU",
    "name": "Kalaburagi"
  },
  {
    "code": "IN-OR-KL",
    "name": "Kalahandi"
  },
  {
    "code": "IN-WB-KA",
    "name": "Kalimpong"
  },
  {
    "code": "IN-TN-KA",
    "name": "Kallakurichi"
  },
  {
    "code": "IN-TS-KM",
    "name": "Kamareddy"
  },
  {
    "code": "IN-MN-KM",
    "name": "Kamjong"
  },
  {
    "code": "IN-AR-KA",
    "name": "Kamle"
  },
  {
    "code": "IN-AS-KP",
    "name": "Kamrup"
  },
  {
    "code": "IN-AS-KM",
    "name": "Kamrup Metropolitan"
  },
  {
    "code": "IN-TN-KC",
    "name": "Kancheepuram"
  },
  {
    "code": "IN-OR-KN",
    "name": "Kandhamal"
  },
  {
    "code": "IN-MN-KN",
    "name": "Kangpokpi"
  },
  {
    "code": "IN-HP-KA",
    "name": "Kangra"
  },
  {
    "code": "IN-CT-KK",
    "name": "Kanker"
  },
  {
    "code": "IN-UP-KJ",
    "name": "Kannauj"
  },
  {
    "code": "IN-TN-KK",
    "name": "Kanniyakumari"
  },
  {
    "code": "IN-KL-KN",
    "name": "Kannur"
  },
  {
    "code": "IN-UP-KD",
    "name": "Kanpur Dehat"
  },
  {
    "code": "IN-UP-KN",
    "name": "Kanpur Nagar"
  },
  {
    "code": "IN-PB-KA",
    "name": "Kapurthala"
  },
  {
    "code": "IN-PY-KA",
    "name": "Karaikal"
  },
  {
    "code": "IN-RJ-KA",
    "name": "Karauli"
  },
  {
    "code": "IN-AS-KA",
    "name": "Karbi Anglong"
  },
  {
    "code": "IN-LA-KA",
    "name": "Kargil"
  },
  {
    "code": "IN-AS-KR",
    "name": "Karimganj"
  },
  {
    "code": "IN-TS-KA",
    "name": "Karimnagar"
  },
  {
    "code": "IN-HR-KR",
    "name": "Karnal"
  },
  {
    "code": "IN-TN-KR",
    "name": "Karur"
  },
  {
    "code": "IN-KL-KS",
    "name": "Kasaragod"
  },
  {
    "code": "IN-UP-KM",
    "name": "Kasganj"
  },
  {
    "code": "IN-JK-KT",
    "name": "Kathua"
  },
  {
    "code": "IN-BR-KT",
    "name": "Katihar"
  },
  {
    "code": "IN-MP-KA",
    "name": "Katni"
  },
  {
    "code": "IN-UP-KS",
    "name": "Kaushambi"
  },
  {
    "code": "IN-OR-KP",
    "name": "Kendrapara"
  },
  {
    "code": "IN-OR-KJ",
    "name": "Kendujhar"
  },
  {
    "code": "IN-BR-KH",
    "name": "Khagaria"
  },
  {
    "code": "IN-TS-KH",
    "name": "Khammam"
  },
  {
    "code": "IN-MP-EN",
    "name": "Khandwa"
  },
  {
    "code": "IN-MP-WN",
    "name": "Khargone"
  },
  {
    "code": "IN-MZ-KZ",
    "name": "Khawzawl"
  },
  {
    "code": "IN-GJ-KH",
    "name": "Kheda"
  },
  {
    "code": "IN-OR-KH",
    "name": "Khordha"
  },
  {
    "code": "IN-TR-KH",
    "name": "Khowai"
  },
  {
    "code": "IN-JH-KH",
    "name": "Khunti"
  },
  {
    "code": "IN-HP-KI",
    "name": "Kinnaur"
  },
  {
    "code": "IN-NL-KI",
    "name": "Kiphire"
  },
  {
    "code": "IN-BR-KI",
    "name": "Kishanganj"
  },
  {
    "code": "IN-JK-KS",
    "name": "Kishtwar"
  },
  {
    "code": "IN-KA-KD",
    "name": "Kodagu"
  },
  {
    "code": "IN-JH-KO",
    "name": "Koderma"
  },
  {
    "code": "IN-NL-KO",
    "name": "Kohima"
  },
  {
    "code": "IN-AS-KK",
    "name": "Kokrajhar"
  },
  {
    "code": "IN-KA-KL",
    "name": "Kolar"
  },
  {
    "code": "IN-MZ-KO",
    "name": "Kolasib"
  },
  {
    "code": "IN-MH-KO",
    "name": "Kolhapur"
  },
  {
    "code": "IN-WB-KO",
    "name": "Kolkata"
  },
  {
    "code": "IN-KL-KL",
    "name": "Kollam"
  },
  {
    "code": "IN-CT-KO",
    "name": "Kondagaon"
  },
  {
    "code": "IN-KA-KP",
    "name": "Koppal"
  },
  {
    "code": "IN-OR-KO",
    "name": "Koraput"
  },
  {
    "code": "IN-CT-KB",
    "name": "Korba"
  },
  {
    "code": "IN-CT-KJ",
    "name": "Korea"
  },
  {
    "code": "IN-RJ-KO",
    "name": "Kota"
  },
  {
    "code": "IN-KL-KT",
    "name": "Kottayam"
  },
  {
    "code": "IN-KL-KZ",
    "name": "Kozhikode"
  },
  {
    "code": "IN-AR-KD",
    "name": "Kra Daadi"
  },
  {
    "code": "IN-AP-KR",
    "name": "Krishna"
  },
  {
    "code": "IN-TN-KS",
    "name": "Krishnagiri"
  },
  {
    "code": "IN-JK-KL",
    "name": "Kulgam"
  },
  {
    "code": "IN-HP-KU",
    "name": "Kullu"
  },
  {
    "code": "IN-TS-KB",
    "name": "Kumuram Bheem Asifabad"
  },
  {
    "code": "IN-JK-KU",
    "name": "Kupwara"
  },
  {
    "code": "IN-AP-KU",
    "name": "Kurnool"
  },
  {
    "code": "IN-HR-KU",
    "name": "Kurukshetra"
  },
  {
    "code": "IN-AR-KK",
    "name": "Kurung Kumey"
  },
  {
    "code": "IN-UP-KU",
    "name": "Kushinagar"
  },
  {
    "code": "IN-HP-LS",
    "name": "Lahaul and Spiti"
  },
  {
    "code": "IN-AS-LA",
    "name": "Lakhimpur"
  },
  {
    "code": "IN-UP-LK",
    "name": "Lakhimpur Kheri"
  },
  {
    "code": "IN-BR-LA",
    "name": "Lakhisarai"
  },
  {
    "code": "IN-LD-LD",
    "name": "Lakshadweep"
  },
  {
    "code": "IN-UP-LA",
    "name": "Lalitpur"
  },
  {
    "code": "IN-JH-LA",
    "name": "Latehar"
  },
  {
    "code": "IN-MH-LA",
    "name": "Latur"
  },
  {
    "code": "IN-MZ-LA",
    "name": "Lawngtlai"
  },
  {
    "code": "IN-LA-LE",
    "name": "Leh"
  },
  {
    "code": "IN-AR-LR",
    "name": "Lepa Rada"
  },
  {
    "code": "IN-JH-LO",
    "name": "Lohardaga"
  },
  {
    "code": "IN-AR-LO",
    "name": "Lohit"
  },
  {
    "code": "IN-AR-LN",
    "name": "Longding"
  },
  {
    "code": "IN-NL-LO",
    "name": "Longleng"
  },
  {
    "code": "IN-AR-LD",
    "name": "Lower Dibang Valley"
  },
  {
    "code": "IN-AR-LS",
    "name": "Lower Siang"
  },
  {
    "code": "IN-AR-LB",
    "name": "Lower Subansiri"
  },
  {
    "code": "IN-UP-LU",
    "name": "Lucknow"
  },
  {
    "code": "IN-PB-LU",
    "name": "Ludhiana"
  },
  {
    "code": "IN-MZ-LU",
    "name": "Lunglei"
  },
  {
    "code": "IN-BR-MP",
    "name": "Madhepura"
  },
  {
    "code": "IN-BR-MB",
    "name": "Madhubani"
  },
  {
    "code": "IN-TN-MA",
    "name": "Madurai"
  },
  {
    "code": "IN-TS-MH",
    "name": "Mahabubabad"
  },
  {
    "code": "IN-TS-MA",
    "name": "Mahabubnagar"
  },
  {
    "code": "IN-UP-MG",
    "name": "Maharajganj"
  },
  {
    "code": "IN-CT-MA",
    "name": "Mahasamund"
  },
  {
    "code": "IN-PY-MA",
    "name": "Mahe"
  },
  {
    "code": "IN-HR-MA",
    "name": "Mahendragarh"
  },
  {
    "code": "IN-GJ-MG",
    "name": "Mahisagar"
  },
  {
    "code": "IN-UP-MH",
    "name": "Mahoba"
  },
  {
    "code": "IN-UP-MP",
    "name": "Mainpuri"
  },
  {
    "code": "IN-AS-MJ",
    "name": "Majuli"
  },
  {
    "code": "IN-KL-MA",
    "name": "Malappuram"
  },
  {
    "code": "IN-WB-MA",
    "name": "Malda"
  },
  {
    "code": "IN-OR-ML",
    "name": "Malkangiri"
  },
  {
    "code": "IN-MZ-MA",
    "name": "Mamit"
  },
  {
    "code": "IN-TS-MN",
    "name": "Mancherial"
  },
  {
    "code": "IN-HP-MA",
    "name": "Mandi"
  },
  {
    "code": "IN-MP-ML",
    "name": "Mandla"
  },
  {
    "code": "IN-MP-MS",
    "name": "Mandsaur"
  },
  {
    "code": "IN-KA-MA",
    "name": "Mandya"
  },
  {
    "code": "IN-PB-MA",
    "name": "Mansa"
  },
  {
    "code": "IN-UP-MT",
    "name": "Mathura"
  },
  {
    "code": "IN-UP-MA",
    "name": "Mau"
  },
  {
    "code": "IN-OR-MY",
    "name": "Mayurbhanj"
  },
  {
    "code": "IN-TS-ME",
    "name": "Medak"
  },
  {
    "code": "IN-TS-MM",
    "name": "Medchal Malkajgiri"
  },
  {
    "code": "IN-UP-ME",
    "name": "Meerut"
  },
  {
    "code": "IN-GJ-MA",
    "name": "Mehsana"
  },
  {
    "code": "IN-JK-MI",
    "name": "Mirpur"
  },
  {
    "code": "IN-UP-MI",
    "name": "Mirzapur"
  },
  {
    "code": "IN-PB-MO",
    "name": "Moga"
  },
  {
    "code": "IN-NL-MK",
    "name": "Mokokchung"
  },
  {
    "code": "IN-NL-MN",
    "name": "Mon"
  },
  {
    "code": "IN-UP-MO",
    "name": "Moradabad"
  },
  {
    "code": "IN-GJ-MO",
    "name": "Morbi"
  },
  {
    "code": "IN-MP-MO",
    "name": "Morena"
  },
  {
    "code": "IN-AS-MA",
    "name": "Morigaon"
  },
  {
    "code": "IN-TS-MU",
    "name": "Mulugu"
  },
  {
    "code": "IN-MH-MC",
    "name": "Mumbai"
  },
  {
    "code": "IN-MH-MS",
    "name": "Mumbai Suburban"
  },
  {
    "code": "IN-CT-MU",
    "name": "Mungeli"
  },
  {
    "code": "IN-BR-MG",
    "name": "Munger"
  },
  {
    "code": "IN-WB-MU",
    "name": "Murshidabad"
  },
  {
    "code": "IN-JK-MU",
    "name": "Muzaffarabad"
  },
  {
    "code": "IN-UP-MU",
    "name": "Muzaffarnagar"
  },
  {
    "code": "IN-BR-MZ",
    "name": "Muzaffarpur"
  },
  {
    "code": "IN-KA-MY",
    "name": "Mysuru"
  },
  {
    "code": "IN-OR-NB",
    "name": "Nabarangapur"
  },
  {
    "code": "IN-WB-NA",
    "name": "Nadia"
  },
  {
    "code": "IN-AS-NG",
    "name": "Nagaon"
  },
  {
    "code": "IN-TN-NG",
    "name": "Nagapattinam"
  },
  {
    "code": "IN-TS-NG",
    "name": "Nagarkurnool"
  },
  {
    "code": "IN-RJ-NA",
    "name": "Nagaur"
  },
  {
    "code": "IN-MH-NG",
    "name": "Nagpur"
  },
  {
    "code": "IN-UL-NA",
    "name": "Nainital"
  },
  {
    "code": "IN-BR-NL",
    "name": "Nalanda"
  },
  {
    "code": "IN-AS-NL",
    "name": "Nalbari"
  },
  {
    "code": "IN-TS-NA",
    "name": "Nalgonda"
  },
  {
    "code": "IN-TN-NM",
    "name": "Namakkal"
  },
  {
    "code": "IN-AR-NA",
    "name": "Namsai"
  },
  {
    "code": "IN-MH-ND",
    "name": "Nanded"
  },
  {
    "code": "IN-MH-NB",
    "name": "Nandurbar"
  },
  {
    "code": "IN-TS-NR",
    "name": "Narayanpet"
  },
  {
    "code": "IN-CT-NA",
    "name": "Narayanpur"
  },
  {
    "code": "IN-GJ-NR",
    "name": "Narmada"
  },
  {
    "code": "IN-MP-HO",
    "name": "Narmadapuram"
  },
  {
    "code": "IN-MP-NA",
    "name": "Narsinghpur"
  },
  {
    "code": "IN-MH-NS",
    "name": "Nashik"
  },
  {
    "code": "IN-GJ-NV",
    "name": "Navsari"
  },
  {
    "code": "IN-BR-NW",
    "name": "Nawada"
  },
  {
    "code": "IN-OR-NY",
    "name": "Nayagarh"
  },
  {
    "code": "IN-MP-NE",
    "name": "Neemuch"
  },
  {
    "code": "IN-DL-ND",
    "name": "New Delhi"
  },
  {
    "code": "IN-AN-NI",
    "name": "Nicobar"
  },
  {
    "code": "IN-TS-NM",
    "name": "Nirmal"
  },
  {
    "code": "IN-MP-NI",
    "name": "Niwari"
  },
  {
    "code": "IN-TS-NI",
    "name": "Nizamabad"
  },
  {
    "code": "IN-MN-NO",
    "name": "Noney"
  },
  {
    "code": "IN-WB-PN",
    "name": "North 24 Parganas"
  },
  {
    "code": "IN-AN-AN",
    "name": "North and Middle Andaman"
  },
  {
    "code": "IN-DL-NO",
    "name": "North Delhi"
  },
  {
    "code": "IN-DL-NE",
    "name": "North East Delhi"
  },
  {
    "code": "IN-ML-NG",
    "name": "North Garo Hills"
  },
  {
    "code": "IN-GA-NG",
    "name": "North Goa"
  },
  {
    "code": "IN-SK-NS",
    "name": "North Sikkim"
  },
  {
    "code": "IN-TR-NT",
    "name": "North Tripura"
  },
  {
    "code": "IN-DL-NW",
    "name": "North West Delhi"
  },
  {
    "code": "IN-OR-NU",
    "name": "Nuapada"
  },
  {
    "code": "IN-HR-ME",
    "name": "Nuh"
  },
  {
    "code": "IN-MH-OS",
    "name": "Osmanabad"
  },
  {
    "code": "IN-AR-PK",
    "name": "Pakke Kessang"
  },
  {
    "code": "IN-JH-PK",
    "name": "Pakur"
  },
  {
    "code": "IN-KL-PL",
    "name": "Palakkad"
  },
  {
    "code": "IN-JH-PL",
    "name": "Palamu"
  },
  {
    "code": "IN-MH-PG",
    "name": "Palghar"
  },
  {
    "code": "IN-RJ-PA",
    "name": "Pali"
  },
  {
    "code": "IN-HR-PL",
    "name": "Palwal"
  },
  {
    "code": "IN-HR-PK",
    "name": "Panchkula"
  },
  {
    "code": "IN-GJ-PM",
    "name": "Panchmahal"
  },
  {
    "code": "IN-HR-PP",
    "name": "Panipat"
  },
  {
    "code": "IN-MP-PA",
    "name": "Panna"
  },
  {
    "code": "IN-AR-PA",
    "name": "Papum Pare"
  },
  {
    "code": "IN-MH-PA",
    "name": "Parbhani"
  },
  {
    "code": "IN-WB-PA",
    "name": "Paschim Bardhaman"
  },
  {
    "code": "IN-WB-MW",
    "name": "Paschim Medinipur"
  },
  {
    "code": "IN-BR-WC",
    "name": "Pashchim Champaran"
  },
  {
    "code": "IN-GJ-PA",
    "name": "Patan"
  },
  {
    "code": "IN-KL-PT",
    "name": "Pathanamthitta"
  },
  {
    "code": "IN-PB-PK",
    "name": "Pathankot"
  },
  {
    "code": "IN-PB-PA",
    "name": "Patiala"
  },
  {
    "code": "IN-BR-PA",
    "name": "Patna"
  },
  {
    "code": "IN-UL-PG",
    "name": "Pauri Garhwal"
  },
  {
    "code": "IN-TS-PE",
    "name": "Peddapalli"
  },
  {
    "code": "IN-TN-PE",
    "name": "Perambalur"
  },
  {
    "code": "IN-NL-PE",
    "name": "Peren"
  },
  {
    "code": "IN-NL-PH",
    "name": "Phek"
  },
  {
    "code": "IN-MN-PE",
    "name": "Pherzawl"
  },
  {
    "code": "IN-UP-PI",
    "name": "Pilibhit"
  },
  {
    "code": "IN-UL-PI",
    "name": "Pithoragarh"
  },
  {
    "code": "IN-JK-PO",
    "name": "Poonch"
  },
  {
    "code": "IN-GJ-PO",
    "name": "Porbandar"
  },
  {
    "code": "IN-AP-PR",
    "name": "Prakasam"
  },
  {
    "code": "IN-UP-PR",
    "name": "Pratapgarh"
  },
  {
    "code": "IN-RJ-PR",
    "name": "Pratapgarh"
  },
  {
    "code": "IN-UP-AH",
    "name": "Prayagraj"
  },
  {
    "code": "IN-PY-PO",
    "name": "Puducherry"
  },
  {
    "code": "IN-TN-PU",
    "name": "Pudukkottai"
  },
  {
    "code": "IN-JK-PU",
    "name": "Pulwama"
  },
  {
    "code": "IN-MH-PU",
    "name": "Pune"
  },
  {
    "code": "IN-WB-PB",
    "name": "Purba Bardhaman"
  },
  {
    "code": "IN-BR-EC",
    "name": "Purba Champaran"
  },
  {
    "code": "IN-WB-ME",
    "name": "Purba Medinipur"
  },
  {
    "code": "IN-OR-PU",
    "name": "Puri"
  },
  {
    "code": "IN-BR-PU",
    "name": "Purnia"
  },
  {
    "code": "IN-WB-PU",
    "name": "Purulia"
  },
  {
    "code": "IN-UP-RB",
    "name": "Raebareli"
  },
  {
    "code": "IN-KA-RA",
    "name": "Raichur"
  },
  {
    "code": "IN-MH-RG",
    "name": "Raigad"
  },
  {
    "code": "IN-CT-RG",
    "name": "Raigarh"
  },
  {
    "code": "IN-CT-RP",
    "name": "Raipur"
  },
  {
    "code": "IN-MP-RS",
    "name": "Raisen"
  },
  {
    "code": "IN-TS-RS",
    "name": "Rajanna Sircilla"
  },
  {
    "code": "IN-MP-RG",
    "name": "Rajgarh"
  },
  {
    "code": "IN-GJ-RA",
    "name": "Rajkot"
  },
  {
    "code": "IN-CT-RN",
    "name": "Rajnandgaon"
  },
  {
    "code": "IN-JK-RA",
    "name": "Rajouri"
  },
  {
    "code": "IN-RJ-RA",
    "name": "Rajsamand"
  },
  {
    "code": "IN-KA-RM",
    "name": "Ramanagara"
  },
  {
    "code": "IN-TN-RA",
    "name": "Ramanathapuram"
  },
  {
    "code": "IN-JK-RM",
    "name": "Ramban"
  },
  {
    "code": "IN-JH-RM",
    "name": "Ramgarh"
  },
  {
    "code": "IN-UP-RA",
    "name": "Rampur"
  },
  {
    "code": "IN-JH-RA",
    "name": "Ranchi"
  },
  {
    "code": "IN-TS-RA",
    "name": "Ranga Reddy"
  },
  {
    "code": "IN-TN-RN",
    "name": "Ranipet"
  },
  {
    "code": "IN-MP-RL",
    "name": "Ratlam"
  },
  {
    "code": "IN-MH-RT",
    "name": "Ratnagiri"
  },
  {
    "code": "IN-OR-RA",
    "name": "Rayagada"
  },
  {
    "code": "IN-JK-RE",
    "name": "Reasi"
  },
  {
    "code": "IN-MP-RE",
    "name": "Rewa"
  },
  {
    "code": "IN-HR-RE",
    "name": "Rewari"
  },
  {
    "code": "IN-ML-RB",
    "name": "Ri-Bhoi"
  },
  {
    "code": "IN-HR-RO",
    "name": "Rohtak"
  },
  {
    "code": "IN-BR-RO",
    "name": "Rohtas"
  },
  {
    "code": "IN-UL-RP",
    "name": "Rudraprayag"
  },
  {
    "code": "IN-PB-RU",
    "name": "Rupnagar"
  },
  {
    "code": "IN-GJ-SK",
    "name": "Sabarkantha"
  },
  {
    "code": "IN-MP-SG",
    "name": "Sagar"
  },
  {
    "code": "IN-UP-SA",
    "name": "Saharanpur"
  },
  {
    "code": "IN-BR-SH",
    "name": "Saharsa"
  },
  {
    "code": "IN-JH-SA",
    "name": "Sahibganj"
  },
  {
    "code": "IN-PB-SH",
    "name": "Sahibzada Ajit Singh Nagar"
  },
  {
    "code": "IN-MZ-ST",
    "name": "Saitual"
  },
  {
    "code": "IN-TN-SA",
    "name": "Salem"
  },
  {
    "code": "IN-BR-SM",
    "name": "Samastipur"
  },
  {
    "code": "IN-JK-SA",
    "name": "Samba"
  },
  {
    "code": "IN-OR-SA",
    "name": "Sambalpur"
  },
  {
    "code": "IN-UP-SM",
    "name": "Sambhal"
  },
  {
    "code": "IN-TS-SR",
    "name": "Sangareddy"
  },
  {
    "code": "IN-MH-SN",
    "name": "Sangli"
  },
  {
    "code": "IN-PB-SA",
    "name": "Sangrur"
  },
  {
    "code": "IN-UP-SK",
    "name": "Sant Kabir Nagar"
  },
  {
    "code": "IN-JH-SR",
    "name": "Saraikela-Kharsawan"
  },
  {
    "code": "IN-BR-SR",
    "name": "Saran"
  },
  {
    "code": "IN-MH-ST",
    "name": "Satara"
  },
  {
    "code": "IN-MP-ST",
    "name": "Satna"
  },
  {
    "code": "IN-RJ-SM",
    "name": "Sawai Madhopur"
  },
  {
    "code": "IN-MP-SR",
    "name": "Sehore"
  },
  {
    "code": "IN-MN-SE",
    "name": "Senapati"
  },
  {
    "code": "IN-MP-SO",
    "name": "Seoni"
  },
  {
    "code": "IN-TR-SO",
    "name": "Sepahijala"
  },
  {
    "code": "IN-MZ-SE",
    "name": "Serchhip"
  },
  {
    "code": "IN-DL-SH",
    "name": "Shahdara"
  },
  {
    "code": "IN-MP-SH",
    "name": "Shahdol"
  },
  {
    "code": "IN-PB-NS",
    "name": "Shaheed Bhagat Singh Nagar"
  },
  {
    "code": "IN-UP-SJ",
    "name": "Shahjahanpur"
  },
  {
    "code": "IN-MP-SJ",
    "name": "Shajapur"
  },
  {
    "code": "IN-UP-SH",
    "name": "Shamli"
  },
  {
    "code": "IN-BR-SP",
    "name": "Sheikhpura"
  },
  {
    "code": "IN-BR-SO",
    "name": "Sheohar"
  },
  {
    "code": "IN-MP-SP",
    "name": "Sheopur"
  },
  {
    "code": "IN-AR-SY",
    "name": "Shi Yomi"
  },
  {
    "code": "IN-HP-SH",
    "name": "Shimla"
  },
  {
    "code": "IN-KA-SH",
    "name": "Shivamogga"
  },
  {
    "code": "IN-MP-SV",
    "name": "Shivpuri"
  },
  {
    "code": "IN-JK-SH",
    "name": "Shopian"
  },
  {
    "code": "IN-UP-SV",
    "name": "Shrawasti"
  },
  {
    "code": "IN-MZ-SA",
    "name": "Siaha"
  },
  {
    "code": "IN-AR-SI",
    "name": "Siang"
  },
  {
    "code": "IN-UP-SN",
    "name": "Siddharthnagar"
  },
  {
    "code": "IN-TS-SI",
    "name": "Siddipet"
  },
  {
    "code": "IN-MP-SI",
    "name": "Sidhi"
  },
  {
    "code": "IN-RJ-SK",
    "name": "Sikar"
  },
  {
    "code": "IN-JH-SI",
    "name": "Simdega"
  },
  {
    "code": "IN-MH-SI",
    "name": "Sindhudurg"
  },
  {
    "code": "IN-MP-SN",
    "name": "Singrauli"
  },
  {
    "code": "IN-HP-SI",
    "name": "Sirmaur"
  },
  {
    "code": "IN-RJ-SR",
    "name": "Sirohi"
  },
  {
    "code": "IN-HR-SI",
    "name": "Sirsa"
  },
  {
    "code": "IN-BR-ST",
    "name": "Sitamarhi"
  },
  {
    "code": "IN-UP-SI",
    "name": "Sitapur"
  },
  {
    "code": "IN-TN-SI",
    "name": "Sivagangai"
  },
  {
    "code": "IN-AS-SI",
    "name": "Sivasagar"
  },
  {
    "code": "IN-BR-SW",
    "name": "Siwan"
  },
  {
    "code": "IN-HP-SO",
    "name": "Solan"
  },
  {
    "code": "IN-MH-SO",
    "name": "Solapur"
  },
  {
    "code": "IN-UP-SO",
    "name": "Sonbhadra"
  },
  {
    "code": "IN-HR-SO",
    "name": "Sonipat"
  },
  {
    "code": "IN-AS-SO",
    "name": "Sonitpur"
  },
  {
    "code": "IN-WB-PS",
    "name": "South 24 Parganas"
  },
  {
    "code": "IN-AN-AS",
    "name": "South Andaman"
  },
  {
    "code": "IN-DL-SO",
    "name": "South Delhi"
  },
  {
    "code": "IN-DL-SE",
    "name": "South East Delhi"
  },
  {
    "code": "IN-ML-SG",
    "name": "South Garo Hills"
  },
  {
    "code": "IN-GA-SG",
    "name": "South Goa"
  },
  {
    "code": "IN-AS-SS",
    "name": "South Salmara-Mankachar"
  },
  {
    "code": "IN-SK-SS",
    "name": "South Sikkim"
  },
  {
    "code": "IN-TR-ST",
    "name": "South Tripura"
  },
  {
    "code": "IN-DL-SW",
    "name": "South West Delhi"
  },
  {
    "code": "IN-ML-SW",
    "name": "South West Garo Hills"
  },
  {
    "code": "IN-ML-SK",
    "name": "South West Khasi Hills"
  },
  {
    "code": "IN-RJ-GA",
    "name": "Sri Ganganagar"
  },
  {
    "code": "IN-PB-MU",
    "name": "Sri Muktsar Sahib"
  },
  {
    "code": "IN-AP-NE",
    "name": "Sri Potti Sriramulu Nellore"
  },
  {
    "code": "IN-AP-SR",
    "name": "Srikakulam"
  },
  {
    "code": "IN-JK-SR",
    "name": "Srinagar"
  },
  {
    "code": "IN-OR-SO",
    "name": "Subarnapur"
  },
  {
    "code": "IN-CT-SK",
    "name": "Sukma"
  },
  {
    "code": "IN-UP-SU",
    "name": "Sultanpur"
  },
  {
    "code": "IN-OR-SU",
    "name": "Sundargarh"
  },
  {
    "code": "IN-BR-SU",
    "name": "Supaul"
  },
  {
    "code": "IN-CT-SR",
    "name": "Surajpur"
  },
  {
    "code": "IN-GJ-ST",
    "name": "Surat"
  },
  {
    "code": "IN-GJ-SN",
    "name": "Surendranagar"
  },
  {
    "code": "IN-CT-SU",
    "name": "Surguja"
  },
  {
    "code": "IN-TS-SU",
    "name": "Suryapet"
  },
  {
    "code": "IN-MN-TA",
    "name": "Tamenglong"
  },
  {
    "code": "IN-GJ-TA",
    "name": "Tapi"
  },
  {
    "code": "IN-PB-TA",
    "name": "Tarn Taran"
  },
  {
    "code": "IN-AR-TA",
    "name": "Tawang"
  },
  {
    "code": "IN-UL-TG",
    "name": "Tehri Garhwal"
  },
  {
    "code": "IN-MN-TE",
    "name": "Tengnoupal"
  },
  {
    "code": "IN-TN-TE",
    "name": "Tenkasi"
  },
  {
    "code": "IN-MH-TH",
    "name": "Thane"
  },
  {
    "code": "IN-TN-TJ",
    "name": "Thanjavur"
  },
  {
    "code": "IN-TN-NI",
    "name": "The Nilgiris"
  },
  {
    "code": "IN-TN-TH",
    "name": "Theni"
  },
  {
    "code": "IN-TN-TL",
    "name": "Thiruvallur"
  },
  {
    "code": "IN-KL-TV",
    "name": "Thiruvananthapuram"
  },
  {
    "code": "IN-TN-TR",
    "name": "Thiruvarur"
  },
  {
    "code": "IN-TN-TK",
    "name": "Thoothukudi"
  },
  {
    "code": "IN-MN-TH",
    "name": "Thoubal"
  },
  {
    "code": "IN-KL-TS",
    "name": "Thrissur"
  },
  {
    "code": "IN-MP-TI",
    "name": "Tikamgarh"
  },
  {
    "code": "IN-AS-TI",
    "name": "Tinsukia"
  },
  {
    "code": "IN-AR-TI",
    "name": "Tirap"
  },
  {
    "code": "IN-TN-TC",
    "name": "Tiruchirappalli"
  },
  {
    "code": "IN-TN-TI",
    "name": "Tirunelveli"
  },
  {
    "code": "IN-TN-TU",
    "name": "Tirupathur"
  },
  {
    "code": "IN-TN-TP",
    "name": "Tiruppur"
  },
  {
    "code": "IN-TN-TV",
    "name": "Tiruvannamalai"
  },
  {
    "code": "IN-RJ-TO",
    "name": "Tonk"
  },
  {
    "code": "IN-NL-TU",
    "name": "Tuensang"
  },
  {
    "code": "IN-KA-TU",
    "name": "Tumakuru"
  },
  {
    "code": "IN-RJ-UD",
    "name": "Udaipur"
  },
  {
    "code": "IN-AS-UD",
    "name": "Udalguri"
  },
  {
    "code": "IN-UL-US",
    "name": "Udham Singh Nagar"
  },
  {
    "code": "IN-JK-UD",
    "name": "Udhampur"
  },
  {
    "code": "IN-KA-UD",
    "name": "Udupi"
  },
  {
    "code": "IN-MP-UJ",
    "name": "Ujjain"
  },
  {
    "code": "IN-MN-UK",
    "name": "Ukhrul"
  },
  {
    "code": "IN-MP-UM",
    "name": "Umaria"
  },
  {
    "code": "IN-HP-UN",
    "name": "Una"
  },
  {
    "code": "IN-TR-UN",
    "name": "Unakoti"
  },
  {
    "code": "IN-UP-UN",
    "name": "Unnao"
  },
  {
    "code": "IN-AR-UD",
    "name": "Upper Dibang Valley"
  },
  {
    "code": "IN-AR-US",
    "name": "Upper Siang"
  },
  {
    "code": "IN-AR-UB",
    "name": "Upper Subansiri"
  },
  {
    "code": "IN-WB-UD",
    "name": "Uttar Dinajpur"
  },
  {
    "code": "IN-KA-UK",
    "name": "Uttara Kannada"
  },
  {
    "code": "IN-UL-UT",
    "name": "Uttarkashi"
  },
  {
    "code": "IN-GJ-VD",
    "name": "Vadodara"
  },
  {
    "code": "IN-BR-VA",
    "name": "Vaishali"
  },
  {
    "code": "IN-GJ-VL",
    "name": "Valsad"
  },
  {
    "code": "IN-UP-VA",
    "name": "Varanasi"
  },
  {
    "code": "IN-TN-VE",
    "name": "Vellore"
  },
  {
    "code": "IN-MP-VI",
    "name": "Vidisha"
  },
  {
    "code": "IN-KA-BJ",
    "name": "Vijayapura"
  },
  {
    "code": "IN-TS-VI",
    "name": "Vikarabad"
  },
  {
    "code": "IN-TN-VL",
    "name": "Viluppuram"
  },
  {
    "code": "IN-TN-VR",
    "name": "Virudhunagar"
  },
  {
    "code": "IN-AP-VS",
    "name": "Visakhapatnam"
  },
  {
    "code": "IN-AP-VZ",
    "name": "Vizianagaram"
  },
  {
    "code": "IN-TS-WN",
    "name": "Wanaparthy"
  },
  {
    "code": "IN-TS-WR",
    "name": "Warangal Rural"
  },
  {
    "code": "IN-TS-WU",
    "name": "Warangal Urban"
  },
  {
    "code": "IN-MH-WR",
    "name": "Wardha"
  },
  {
    "code": "IN-MH-WS",
    "name": "Washim"
  },
  {
    "code": "IN-KL-WA",
    "name": "Wayanad"
  },
  {
    "code": "IN-DL-WE",
    "name": "West Delhi"
  },
  {
    "code": "IN-ML-WG",
    "name": "West Garo Hills"
  },
  {
    "code": "IN-AP-WG",
    "name": "West Godavari"
  },
  {
    "code": "IN-ML-WJ",
    "name": "West Jaintia Hills"
  },
  {
    "code": "IN-AR-WK",
    "name": "West Kameng"
  },
  {
    "code": "IN-AS-WK",
    "name": "West Karbi Anglong"
  },
  {
    "code": "IN-ML-WK",
    "name": "West Khasi Hills"
  },
  {
    "code": "IN-AR-WS",
    "name": "West Siang"
  },
  {
    "code": "IN-SK-WS",
    "name": "West Sikkim"
  },
  {
    "code": "IN-JH-WS",
    "name": "West Singhbhum"
  },
  {
    "code": "IN-TR-WT",
    "name": "West Tripura"
  },
  {
    "code": "IN-NL-WO",
    "name": "Wokha"
  },
  {
    "code": "IN-TS-YB",
    "name": "Yadadri Bhuvanagiri"
  },
  {
    "code": "IN-KA-YD",
    "name": "Yadgiri"
  },
  {
    "code": "IN-HR-YN",
    "name": "Yamunanagar"
  },
  {
    "code": "IN-PY-YA",
    "name": "Yanam"
  },
  {
    "code": "IN-MH-YA",
    "name": "Yavatmal"
  },
  {
    "code": "IN-AP-CU",
    "name": "YSR District (Kadapa)"
  },
  {
    "code": "IN-NL-ZU",
    "name": "Zunheboto"
  }
]